import { boot } from 'quasar/wrappers';

type LogLevel = 'info' | 'warn' | 'error' | 'log';

function getQueryStringValue(key: string): string | null {
  return new URLSearchParams(window.location.search).get(key);
}

function trace(
  message: string,
  level: LogLevel = 'info',
  ...params: unknown[]
): void {
  if (localStorage.getItem('log_console') !== 'on') return;

  const dataToLog = [message, ...params];

  switch (level) {
    case 'info':
      console.info(...dataToLog);
      break;
    case 'warn':
      console.warn(...dataToLog);
      break;
    case 'error':
      console.error(...dataToLog);
      break;
    default:
      console.log(...dataToLog);
  }
}

export default boot(() => {
  if (
    getQueryStringValue('debug') === 'on' ||
    process.env.NODE_ENV === 'development'
  ) {
    localStorage.setItem('log_console', 'on');
  }
});

export { trace };
export type { LogLevel };
